import { useQuery } from "@apollo/client";
import { useMemo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DEFAULT_OPERATIONS from "./AccountChip.gql";
import { resetData } from "../../features/login/LoginSlice";
import { saveCartId } from "../../features/Cart/CartSlice";
import { useDropdown } from "../../hooks/useDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { setCompareListId } from "../../features/CompareList/CompareListSlice";

export const useAccountTrigger = () => {
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getCustomerDetails } = DEFAULT_OPERATIONS;
  const location = useLocation();
  const { data } = useQuery(getCustomerDetails, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    skip: !isSignedIn,
    onError: (err) => {
      if (err.message === "The current customer isn't authorized.") {
        dispatch(resetData());
        dispatch(saveCartId(""));
        dispatch(setCompareListId(""));
        navigate("/");
      }
    },
    onCompleted: (data) => {
      localStorage.setItem("userData", JSON.stringify(data.customer));
    },
  });

  const {
    elementRef: accountRef,
    expanded: accountIsOpen,
    setExpanded: setAccountTriggerIsOpen,
    triggerRef: accountTriggerRef,
  } = useDropdown();

  const currentUser = useMemo(() => {
    return (data && data.customer) || null;
  }, [data]);

  const handleAccountTrigger = useCallback(() => {
    setAccountTriggerIsOpen((isOpen) => !isOpen);
  }, [setAccountTriggerIsOpen]);

  useEffect(() => {
    setAccountTriggerIsOpen(false);
  }, [location.pathname]);

  return {
    handleAccountTrigger,
    isSignedIn,
    currentUser,
    accountIsOpen,
    accountRef,
    accountTriggerRef,
  };
};
